import { render, staticRenderFns } from "./SectionPanel.vue?vue&type=template&id=f1640e48&scoped=true&"
import script from "./SectionPanel.vue?vue&type=script&lang=js&"
export * from "./SectionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1640e48",
  null
  
)

export default component.exports